import './Home.scss';
import { useAuth } from '../hooks/useAuth';
import { useExperiment } from '../hooks/useExperiment';
import { Loading } from '../components/Loading';
import { PageContainer } from '../components/PageContainer';
import AuthenticatedHome from '../components/home/AuthenticatedHome';
import UnauthenticatedHome from '../components/home/UnauthenticatedHome';
import UnauthenticatedHomeV2 from '../components/home/UnauthenticatedHomeV2';

const Home = () => {
    const { user, loading } = useAuth();
    const { variantName } = useExperiment('landing-page-redesign-2026');

    if (loading) {
        return <PageContainer>
            <Loading />
        </PageContainer>;
    }

    if (!user) {
        return <UnauthenticatedHomeV2 />;
    }

    return <AuthenticatedHome user={user} />;
};

export default Home;
